/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuditEventResponse } from './AuditEventResponse';
import {
    AuditEventResponseFromJSON,
    AuditEventResponseFromJSONTyped,
    AuditEventResponseToJSON,
    AuditEventResponseToJSONTyped,
} from './AuditEventResponse';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';

/**
 * 
 * @export
 * @interface AuditEventResponsePagedResult
 */
export interface AuditEventResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof AuditEventResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<AuditEventResponse>}
     * @memberof AuditEventResponsePagedResult
     */
    data: Array<AuditEventResponse> | null;
}

/**
 * Check if a given object implements the AuditEventResponsePagedResult interface.
 */
export function instanceOfAuditEventResponsePagedResult(value: object): value is AuditEventResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function AuditEventResponsePagedResultFromJSON(json: any): AuditEventResponsePagedResult {
    return AuditEventResponsePagedResultFromJSONTyped(json, false);
}

export function AuditEventResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEventResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(AuditEventResponseFromJSON)),
    };
}

export function AuditEventResponsePagedResultToJSON(json: any): AuditEventResponsePagedResult {
    return AuditEventResponsePagedResultToJSONTyped(json, false);
}

export function AuditEventResponsePagedResultToJSONTyped(value?: AuditEventResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(AuditEventResponseToJSON)),
    };
}

